module.exports = __webpack_public_path__ + "static/media/pyer-moss.547142eb.jpg";